import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { Tabs } from "../../components/Widget/Tab";

import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  Cross2Icon,
  HomeIcon,
  Pencil1Icon,
  PersonIcon,
  ReloadIcon,
  SewingPinFilledIcon,
  UploadIcon,
} from "@radix-ui/react-icons";
import { Calendar, Download, FileText, Filter, Trash2 } from "lucide-react";
import ReactDatePicker from "react-datepicker";
import toast from "react-hot-toast";
import { checkTagValidity, getUserProfil, userToken } from "../../Utils/Utils";
import {
  ACTUALISER_POSITION,
  BASE_URL,
  CONFIRME_INTENTION,
  FICHIER_ABONNEMENT,
  LIST_INTENTION,
  RAPPORT_PAIEMENT,
} from "../../Utils/constant";
import model from "../../assets/model-fichier/model_abonnement.xlsx";
import { DetailIntention } from "../../components/Abonnement/DetailIntention";
import { UpdateDemandeIntention } from "../../components/Ajouter-intention/UpdateDemandeIntention";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { deleteItem, find, store, updateOne } from "../../services/service";
import { useIntentionStore } from "../../store/intentionStore";

const steps = [
  {
    label: "EN_ATTENTE_DE_CONFIRMATION",
    value: 1,
  },
  {
    label: "EN_ATTENTE_DE_PAIEMENT",
    value: 2,
  },
  {
    label: "EN_ATTENTE_DE_LIVRAISON",
    value: 3,
  },
  {
    label: "EN_ATTENTE_DE_IDENTIFICATION",
    value: 4,
  },
  {
    label: "EN_ATTENTE_DE_RENDEZ_VOUS",
    value: 5,
  },
  {
    label: "EN_ATTENTE_DE_SURVEY",
    value: 6,
  },
  {
    label: "EN_ATTENTE_DE_ACTIVATION",
    value: 7,
  },
  {
    label: "EN_ATTENTE_DE_RENDEZ_VOUS_DE_RACCORDEMENT",
    value: 8,
  },
  {
    label: "EN_ATTENTE_DE_RACCORDEMENT",
    value: 9,
  },
  {
    label: "EN_ATTENTE_DE_SOUSCRIPTION",
    value: 10,
  },
  {
    label: "EN_ATTENTE_DE_TEST",
    value: 11,
  },
];

const ListeAbonnements = () => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const { status } = useParams();
  const navigate = useNavigate();
  const [statusIntention, setStatusIntention] = useState(
    status === "TERMINER" ? status : "",
  );
  const [abonnementStatus, setAbonnementStatus] = useState("ALL");
  const [isSubmit, setIsSubmit] = useState(false);
  const [submit, setSubmit] = useState(false);
  const location = useLocation();
  const [active, setActive] = useState({
    index: 0,
    label: "Liste des abonnement",
    value: "intention",
    status: "",
  });
  const [selectItems, setSelectItem] = useState(null);
  const [fichier, setFichier] = useState([]);
  const [message, setMessage] = useState("");
  const intentions = useIntentionStore();
  const [page, setPage] = useState(0);
  const [selectedId, setSelectedId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const listeTabsData = [
    {
      index: 0,
      value: "Confirmé",
      label: "CONFIRMER",
      tag: "LISTE_CONFIRME",
    },
    {
      index: 1,
      value: "Non confirmé",
      label: "NON_CONFIRMER",
      tag: "LISTE_NON_CONFIRME",
    },
  ];

  const tabs = [
    {
      index: 0,
      label: "intentions",
      value: "Liste des abonnements",
      status: "",
    },
    {
      index: 1,
      label: "en_attente",
      value: "Abonnement en attente de suppression",
      status: "EN_ATTENTE",
    },
  ];
  const [motif, setMotif] = useState("");
  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
    }
  }, []);

  useEffect(() => {
    intentions.intentionList(
      { page: 0, param: ``, size: 8 },
      `&statusSuppression=${active.status}&status=${
        statusIntention === "INACTIF" ? "" : statusIntention
      }&date=&isActive=${
        statusIntention === "INACTIF" ? false : true
      }&sousMenu=${location.pathname.split("/")[2]}`,
    );
  }, [statusIntention, active]);

  const more = (page) => {
    setPage(page - 1);
    intentions.intentionList(
      { page: page - 1, param: "", size: 8 },
      `&statusSuppression=${active.status}&status=${statusIntention}&date=&isActive=${
        statusIntention === "INACTIF" ? false : true
      }&sousMenu=${location.pathname.split("/")[2]}`,
    );
  };

  const handleDownload = () => {
    setSubmit(true);
    const user = getUserProfil();
    if (abonnementStatus !== "") {
      fetch(
        `${BASE_URL + RAPPORT_PAIEMENT}?model=${abonnementStatus}&username=${
          user?.username
        }&dateDebut=${dateRange[0]
          ?.toLocaleDateString()
          .replace(/\//g, "-")}&dateFin=${dateRange[1]
          ?.toLocaleDateString()
          .replace(/\//g, "-")}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        },
      )
        .then((response) => response.blob())
        .then((blob) => {
          setSubmit(null);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = `RAPPORT_${abonnementStatus}.xlsx`; // spécifiez le nom du fichier et son extension
          document.body.appendChild(a);
          a.click();
        })
        .catch((err) => {
          setSubmit(false);
          console.error("Erreur de téléchargement:", err);
        });
    }
  };

  const handleChangeFichier = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setFichier(files);
    }
  };

  const statusOptions = [
    { value: "ALL", label: "Tous les abonnements", icon: "" },
    { value: "PAIEMENTS", label: "Abonnements payés", icon: "" },
    { value: "LIVRAISONS", label: "Abonnements livrés", icon: "" },
    { value: "IDENTIFICATIONS", label: "Abonnements identifiés", icon: "" },
    {
      value: "RENDEZ_VOUS",
      label: "Rendez-vous de survey programmés",
      icon: "",
    },
    { value: "SURVEYS", label: "Surveys réalisés", icon: "" },
    { value: "SOUSCRIPTIONS", label: "Abonnements installés", icon: "" },
    { value: "TESTS", label: "Abonnements testés", icon: "" },
    { value: "PROVISIONING", label: "Abonnements terminés", icon: "" },
  ];

  const updateGeoPosition = (numeroTicket) => {
    setIsSubmit({
      id: numeroTicket,
      statut: true,
    });
    find(ACTUALISER_POSITION + numeroTicket)
      .then((res) => {
        setIsSubmit({
          id: numeroTicket,
          statut: null,
        });
        intentions.intentionList(
          { page: 0, param: ``, size: 8 },
          `&statusSuppression=${active.status}&status=${statusIntention}&date=&isActive=true&sousMenu=${
            location.pathname.split("/")[2]
          }`,
        );
      })
      .catch((err) => {
        toast.error(err?.response?.data?.donnee);
      })
      .finally(() => {
        setIsSubmit({
          id: numeroTicket,
          statut: false,
        });
      });
  };

  return (
    <div className="w-full">
      <div className="lg:flex gap-x-2">
        <div>
          <h1 className="font-mtn text-3xl font-extrabold text-black ">
            Abonnements
          </h1>
          <p className="text-sm text-gray-500">
            Liste des abonnements enregistrés dans le système
          </p>
        </div>
      </div>
      <div className="mt-3 lg:flex gap-1">
        <div className="ml-auto">
          <button
            onClick={() => document.getElementById("upload").showModal()}
            className="mt-2 ml-auto btn btn-sm h-10 bg-black text-white"
          >
            Charger un fichier
          </button>

          <dialog id="upload" className="modal rounded-none backdrop-blur-sm">
            <div className="modal-box p-0 bg-white rounded-2xl shadow-2xl border-0 lg:max-w-md">
              {/* En-tête avec gradient */}
              <div className="bg-gradient-to-r from-black to-black px-6 py-4 rounded-t-2xl">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                      <UploadIcon className="w-5 h-5 text-white" />
                    </div>
                    <h1 className="font-bold text-lg font-mtn text-white">
                      Charger un fichier
                    </h1>
                  </div>
                  <form method="dialog">
                    <button
                      onClick={() => setFichier([])}
                      id="close_upload"
                      className="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors duration-200"
                    >
                      <Cross2Icon className="w-4 h-4 text-white" />
                    </button>
                  </form>
                </div>
              </div>

              <div className="p-3 space-y-3">
                {message && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                    <div className="flex items-start gap-3">
                      <div className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                        <span className="text-red-600 text-xs font-bold">
                          !
                        </span>
                      </div>
                      <p className="text-red-700 text-sm font-medium">
                        {message}
                      </p>
                    </div>
                  </div>
                )}

                <div className="relative">
                  <div
                    className={`
            relative border-2 border-dashed rounded-xl transition-all duration-200
            ${
              fichier.length !== 0
                ? "border-green-300 bg-green-50"
                : "border-gray-300 bg-gray-50 hover:border-blue-400 hover:bg-blue-50"
            }
          `}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.add(
                        "border-blue-400",
                        "bg-blue-50",
                      );
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      if (fichier.length === 0) {
                        e.currentTarget.classList.remove(
                          "border-blue-400",
                          "bg-blue-50",
                        );
                      }
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.remove(
                        "border-blue-400",
                        "bg-blue-50",
                      );
                      const files = Array.from(e.dataTransfer.files);
                      if (files.length > 0) {
                        handleChangeFichier({ target: { files } });
                      }
                    }}
                  >
                    <div className="text-center py-2">
                      <input
                        className="hidden inset-0 w-full h-full"
                        type="file"
                        id="fichier"
                        onChange={handleChangeFichier}
                      />
                      {fichier.length === 0 ? (
                        <>
                          {/* Icône animée */}
                          <div className="mx-auto w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-200">
                            <UploadIcon className="w-8 h-8 text-black" />
                          </div>

                          {/* Texte principal */}
                          <h3 className="text-sm font-semibold text-gray-900">
                            Glissez-déposez votre fichier ici
                          </h3>
                          <p className="text-sm text-gray-500">
                            ou cliquez pour parcourir vos fichiers
                          </p>

                          {/* Input file stylé */}
                          <div className="inline-block py-2">
                            <button
                              onClick={() =>
                                document.getElementById("fichier").click()
                              }
                              type="button"
                              className="bg-main text-black px-6 py-2.5 rounded-lg font-medium text-sm"
                            >
                              Parcourir les fichiers
                            </button>
                          </div>

                          {/* Formats acceptés */}
                          <p className="text-xs text-gray-400 mt-4">
                            Formats supportés: XLS, XLSX
                          </p>
                        </>
                      ) : (
                        <>
                          {/* Fichier sélectionné */}
                          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
                            <svg
                              className="w-8 h-8 text-green-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                          </div>

                          <h3 className="text-lg font-semibold text-green-800 mb-2">
                            Fichier sélectionné
                          </h3>
                          <p className="text-sm text-green-600 font-medium mb-4">
                            {fichier[0]?.name}
                          </p>
                          <p className="text-xs text-gray-500">
                            Taille:{" "}
                            {(fichier[0]?.size / 1024 / 1024).toFixed(2)} MB
                          </p>

                          {/* Bouton pour changer de fichier */}
                          <div className="mt-4">
                            <button
                              onClick={() =>
                                document.getElementById("fichier").click()
                              }
                              type="button"
                              className="text-black text-sm font-medium underline"
                            >
                              Choisir un autre fichier
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between border-gray-100">
                  {model && (
                    <a
                      href={model}
                      download="modelFichier"
                      className="inline-flex items-center gap-2 px-4 py-2 bg-gray-800 hover:bg-gray-900 text-white text-sm font-medium rounded-lg transition-colors duration-200"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      Télécharger le modèle
                    </a>
                  )}

                  {/* Boutons d'action principales */}
                  <div className="flex items-center gap-3 ml-auto">
                    <button
                      onClick={() => {
                        setIsSubmit(true);
                        store(FICHIER_ABONNEMENT, "multipart/form-data", {
                          username: getUserProfil()?.username,
                          liste: fichier[0],
                        })
                          .then((res) => {
                            if (res.status === 200) {
                              setFichier([]);
                              setIsSubmit(null);
                              intentions.intentionList(
                                { page: 0, param: "", size: 8 },
                                `&statusSuppression=${active.status}&status=${statusIntention}&date=&isActive=true&sousMenu=${
                                  location.pathname.split("/")[2]
                                }`,
                              );
                              document.getElementById("close_upload").click();
                              toast.success("Fichier chargé avec succès");
                            }
                          })
                          .catch((err) => {
                            setIsSubmit(false);
                            setMessage(err?.response?.data?.donnee);
                          });
                      }}
                      disabled={isSubmit || fichier.length === 0}
                      className={`
              inline-flex trunca items-center gap-2 px-6 py-2.5 rounded-lg font-medium text-sm transition-all duration-200
              ${
                isSubmit || fichier.length === 0
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-main text-black shadow-sm hover:shadow-md"
              }
            `}
                    >
                      {isSubmit ? (
                        <>
                          <svg
                            className="animate-spin w-4 h-4"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Chargement...
                        </>
                      ) : (
                        <>
                          <UploadIcon className="w-4 h-4" />
                          Charger le fichier
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </dialog>

          <button
            onClick={() => document.getElementById("rapport").showModal()}
            className="mt-2 ml-auto btn btn-sm h-10 bg-black text-white"
          >
            Telecharger le rapport
          </button>

          <dialog id="rapport1" className="modal bg-slate-900/70">
            <div className="modal-box w-11/12 max-w-xl h-96 overflow-visible">
              <div className="flex items-center justify-between p-3">
                <div className="">
                  <h2 className="font-extrabold flex flex-row items-center text-lg mb-8 text-[#000000a8]">
                    Telechargement de rapport
                  </h2>
                </div>
                <form method="dialog">
                  <button
                    onClick={() => setSubmit(null)}
                    id="fermer_create_trajet"
                    className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                  >
                    ✕
                  </button>
                </form>
              </div>
              <div>
                <p className="text-xs">Selectionnez une période</p>
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={startDate}
                  onChange={(update) => {
                    setDateRange(update);
                  }}
                  startDate={startDate}
                  endDate={endDate}
                  selectsRange
                  popperClassName="z-[9999]"
                  className="z-[9999] text-xs font-normal cursor-pointer text-center h-10 my-2 w-full lg:w-[360px] rounded-lg border-2 border-input px-3 py-1"
                />
              </div>

              <div className="lg:flex lg:flex-row gap-2">
                <select
                  onChange={(e) => setAbonnementStatus(e.target.value)}
                  className="select pl-non w-full"
                >
                  <option value="">Selectionnez un element</option>
                  <option value="ALL" selected>
                    Tout les abonnements
                  </option>
                  <option value="PAIEMENTS">Abonnement payé</option>
                  <option value="LIVRAISONS">Abonnement livré</option>
                  <option value="IDENTIFICATIONS">Abonnement identifié</option>
                  <option value="RENDEZ_VOUS">
                    Rendez-vous de survey programmé
                  </option>
                  <option value="SURVEYS">
                    Abonnement pour Survey Realisé
                  </option>
                  <option value="ACTIVATIONS">Abonnement Activée</option>
                  <option value="RACCORDEMENTS">Abonnement raccordée</option>
                  <option value="SOUSCRIPTIONS">Abonnement souscrit</option>
                  <option value="TESTS">Abonnement testé</option>
                  <option value="PROVISIONING">Abonnement provisioning</option>
                </select>
                <button
                  onClick={handleDownload}
                  className="btn btn-sm bg-main text-xs"
                >
                  Telecharger le rapport
                </button>
              </div>
            </div>
          </dialog>

          <dialog id="rapport" className="modal bg-black/60 backdrop-blur-sm">
            <div className="bg-white rounded-xl overflow-visible">
              <div className="">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-100">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-blue-100 rounded-xl">
                      <FileText className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <h2 className="text-xl font-mtn font-bold text-gray-900">
                        Téléchargement de rapport
                      </h2>

                      <p className="text-xs text-gray-500">
                        Générez et téléchargez votre rapport personnalisé
                      </p>
                    </div>
                  </div>
                  <form method="dialog">
                    <button
                      onClick={() => setSubmit(null)}
                      id="fermer_create_trajet"
                      className="w-8 h-8 flex items-center justify-center rounded-lg bg-neutral-100"
                    >
                      ✕
                    </button>
                  </form>
                </div>

                {/* Content */}
                <div className="p-6 space-y-6">
                  {/* Date Range Section */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-blue-600" />
                      <label className="text-sm font-semibold text-gray-700">
                        Sélectionnez une période
                      </label>
                    </div>
                    <ReactDatePicker
                      dateFormat="dd-MM-yyyy"
                      selected={startDate}
                      onChange={(update) => {
                        setDateRange(update);
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      popperClassName="z-[9999]"
                      className="z-[9999] text-xs font-normal cursor-pointer h-10 my-2 w-full lg:w-[460px] rounded-lg border-2 border-input px-3 py-1"
                    />
                  </div>

                  {/* Filter Section */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-2">
                      <Filter className="w-4 h-4 text-blue-600" />
                      <label className="text-sm font-semibold text-gray-700">
                        Type d'abonnement
                      </label>
                    </div>
                    <div className="relative">
                      <select
                        value={abonnementStatus}
                        onChange={(e) => setAbonnementStatus(e.target.value)}
                        className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm appearance-none bg-white cursor-pointer"
                      >
                        {statusOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.icon} {option.label}
                          </option>
                        ))}
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center px-3 pointer-events-none">
                        <svg
                          className="w-4 h-4 text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Preview Card */}
                  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-blue-100 rounded-lg">
                        <FileText className="w-4 h-4 text-blue-600" />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-blue-900">
                          Aperçu du rapport
                        </p>
                        <p className="text-xs text-blue-700">
                          {statusOptions.find(
                            (opt) => opt.value === abonnementStatus,
                          )?.label || "Sélectionnez un type"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="flex items-center justify-between p-6 bg-gray-50 rounded-b-2xl">
                  <div className="text-xs text-gray-500">
                    Le rapport sera généré au format PDF
                  </div>
                  <div className="flex gap-3">
                    <button
                      onClick={handleDownload}
                      className="flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-black to-neutral-800  text-white text-sm font-semibold rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
                    >
                      <Download className="w-4 h-4" />
                      Télécharger
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </dialog>

          {checkTagValidity("AJOUTER_INTENTION") ? (
            <button
              onClick={() => {
                navigate("enregistrement-intention");
              }}
              className="mt-2 btn btn-sm h-10 hover:bg-[#ffcb05] bg-[#ffcb05] "
            >
              Ajouter une intention
            </button>
          ) : null}
        </div>
      </div>
      <Tabs tabsData={tabs} active={active} setActive={setActive} />
      <div className="my-3 lg:flex lg:flex-row md:flex-row xl:flex-row flex-col w-full justify-start items-start lg:items-center md:items-center xl:items-center  gap-2">
        <input
          onChange={(e) => {
            intentions.intentionList(
              { page: 0, param: e.target.value, size: 8 },
              `&statusSuppression=${active.status}&status=${statusIntention}&date=&isActive=true&sousMenu=${
                location.pathname.split("/")[2]
              }`,
            );
          }}
          type="text"
          placeholder="Rechercher element..."
          className="text-xs input input-bordered px-3 w-80 h-9 text-gray-900 placeholder:text-gray-400"
        />
        {active && active.value !== "NON_CONFIRMER" ? (
          <div className="lg:flex lg:flex-row justify-center items-center gap-2">
            <select
              onChange={(e) => setStatusIntention(e.target.value)}
              className="select pl-non"
            >
              <option selected value="">
                Tout les abonnements
              </option>
              <option value="TERMINER">Terminer</option>
              <option value="INACTIF">Abonnement inactif</option>
              <option value="EN_ATTENTE_DE_PAIEMENT">
                En attente de paiement
              </option>
              <option value="EN_ATTENTE_DE_LIVRAISON">
                En attente de livraison
              </option>
              <option value="EN_ATTENTE_DE_IDENTIFICATION">
                En attente d'identification
              </option>
              <option value="EN_ATTENTE_DE_SURVEY">En attente de survey</option>
              <option value="EN_ATTENTE_DE_ACTIVATION">
                En attente d'activation
              </option>
              <option value="EN_ATTENTE_DE_RACCORDEMENT">
                En attente de raccordement
              </option>
              <option value="EN_ATTENTE_DE_SOUSCRIPTION">
                En attente de souscription
              </option>
              <option value="EN_ATTENTE_DE_TEST">En attente de test</option>
              <option value="EN_ATTENTE_PROVISIONING">
                En attente de provisioning
              </option>
            </select>
            <select
              onChange={(e) =>
                intentions.getIntentionByInTime(
                  `${LIST_INTENTION}?page=${page}&param=&size=8&statusSuppression=${active.status}&status=${statusIntention}&date=&isActive=${
                    statusIntention === "INACTIF" ? false : true
                  }&sousMenu=${location.pathname.split("/")[2]}`,
                  e.target.value,
                )
              }
              className="select pl-non"
            >
              <option disabled selected>
                Delais de traitement
              </option>
              <option value="">Tout afficher</option>
              <option value={"true"}>Intention dans le delais</option>
              <option value={"false"}>Intention hors delais</option>
            </select>
          </div>
        ) : null}
      </div>{" "}
      {active ? (
        <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-2 gap-y-3">
          {intentions?.data?.data?.length === 0 ? (
            <div className="">
              <p>Aucune donnée</p>
            </div>
          ) : intentions?.data?.data?.length !== 0 && !intentions?.loading ? (
            intentions?.data?.data?.map((item) => (
              <div
                className={`${
                  !item?.inTime
                    ? "border-red-200 border-2"
                    : "border-slate-200 border"
                } ${
                  item?.statusSuppression === "EN_ATTENTE" && "opacity-35"
                } relative bg-white rounded-xl  shadow-sm`}
              >
                <div className="rounded-t-xl flex items-center justify-between gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                  <p className="text-[12px] font-semibold">
                    N° {item?.numeroTicket}
                  </p>
                  {item?.statusSuppression !== "EN_ATTENTE" &&
                    steps.find((e) => e.label === item.status)?.value <= 5 && (
                      <button
                        onClick={() => {
                          setSelectedId(item?.id);
                          document
                            .getElementById("delete-intention")
                            .showModal();
                        }}
                        className="rounded-lg btn-sm text-red-600 bg-red-50 text-xs"
                      >
                        <Trash2 size={15} className="text-red-600" />
                      </button>
                    )}
                </div>
                <div className=" px-3 py-2 ">
                  <div className="items-center gap-2 space-y-3">
                    <Periode item={item} />
                    <Pbo pbo={item?.eligibilite?.pbo?.nom} port={item?.brin} />
                    <div className="flex gap-1 my-3">
                      <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                      <div>
                        <p className="text-[13px] font-medium">
                          {item?.client?.nomPrenoms}
                        </p>
                        <p className="text-xs flex font-semibold gap-2">
                          <span>{item?.client?.numero}</span> {" | "}{" "}
                          <span>{item?.client?.secondNumero}</span>{" "}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center gap-1 my-3">
                      <div>
                        {item?.agent && (
                          <p className="text-[13px] font-medium">
                            Agent : {item?.agent?.nomPrenoms}
                          </p>
                        )}
                      </div>
                    </div>
                    <h1 className="text-xs flex gap-1 items-center my-2">
                      Forfait : {item?.forfait?.designation} -{" "}
                      {item?.forfait?.categorie?.replace("_", "").toLowerCase()}
                    </h1>
                    <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                      <p className="text-xs flex gap-1 items-center font-medium">
                        <HomeIcon />
                        {item?.batiment?.designation}
                      </p>
                      <p className="text-xs flex gap-1 font-medium">
                        <ArchiveIcon /> {item?.equipement?.designation}{" "}
                      </p>
                    </div>
                  </div>
                  <h1 className="my-2 text-[13px] font-medium flex items-center">
                    <SewingPinFilledIcon />
                    {item?.commune + ", " + item?.quartier}
                  </h1>
                  <div className="flex items-center gap-1">
                    <h5 className="text-xs font-medium ">Etape:</h5>
                    <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                      {item?.status.toLowerCase().replace(/_/g, " ")}
                    </p>
                  </div>
                  {item?.status ===
                  "TERMINER" ? null : item?.statusConfirmation ===
                    "NON_CONFIRMER" ? (
                    <button
                      disabled={isSubmit ? true : false}
                      className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                      onClick={() => {
                        setIsSubmit(true);
                        updateOne(CONFIRME_INTENTION, item.id, {})
                          .then((res) => {
                            if (res.status === 200) {
                              intentions.intentionList(
                                { page: 0, param: ``, size: 8 },
                                `&statusConfirmation=${
                                  active.label
                                }&status=${statusIntention}&date=&isActive=true&sousMenu=${
                                  location.pathname.split("/")[2]
                                }`,
                              );
                              toast.success("Intention confirmé");
                            }
                          })
                          .catch((err) => {
                            setIsSubmit(false);
                            toast.error(err?.response?.data?.donnee);
                          });
                      }}
                    >
                      Confirmer
                    </button>
                  ) : (
                    <div className="flex items-center my-1">
                      {item?.commune === "Sanpedro" && (
                        <button
                          disabled={
                            isSubmit?.id === item?.id ? isSubmit?.statut : false
                          }
                          className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                          onClick={() => updateGeoPosition(item?.numeroTicket)}
                        >
                          {isSubmit?.id === item?.id && isSubmit.statut ? (
                            <div className="h-5 w-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                          ) : (
                            <>
                              <ReloadIcon /> Actualiser
                            </>
                          )}
                        </button>
                      )}

                      {item?.statusSuppression !== "EN_ATTENTE" && (
                        <>
                          {checkTagValidity("POURSUIVRE") ? (
                            <NavLink
                              className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                              to={`poursuivre-intention/${item?.numeroTicket}/${
                                steps.find((e) => e.label === item.status)
                                  ?.value
                              }`}
                            >
                              Poursuivre l'etape
                            </NavLink>
                          ) : null}
                          {checkTagValidity("MODIFIER") ? (
                            <button
                              onClick={() => {
                                setSelectItem(item);
                                document.getElementById("edit").showModal();
                              }}
                              className="ml-auto text-white text-xs btn btn-sm bg-black"
                            >
                              <Pencil1Icon /> Modifier
                            </button>
                          ) : null}
                          {checkTagValidity("DETAILS_INTENTION") ? (
                            <button
                              className="btn bg-main text-xs btn-sm"
                              onClick={() => {
                                document
                                  .getElementById(`show${item.id}`)
                                  .showModal();
                              }}
                            >
                              Details
                            </button>
                          ) : null}
                        </>
                      )}

                      <dialog id="delete-intention" className="modal">
                        <div className="modal-box max-w-md bg-white rounded-2xl shadow-2xl">
                          <div className="text-center p-6">
                            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                              <Trash2 className="h-8 w-8 text-red-600" />
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">
                              Demande de suppression d'abonnement
                            </h3>
                            <p className="text-gray-600 mb-6 text-xs">
                              Êtes-vous sûr de vouloir demander la suppression
                              de cet abonnement ? Cette action nécessitera une
                              validation ultérieure par un administrateur.
                            </p>

                            <div>
                              <p className="text-left text-sm my-2">
                                Motif de suppression
                              </p>
                              <textarea
                                value={motif}
                                onChange={(e) => setMotif(e.target.value)}
                                className="w-full border border-gray-300 rounded-lg p-2 mb-4"
                                rows={3}
                                placeholder="Entrez le motif de suppression"
                              ></textarea>
                            </div>
                            <div className="flex items-center justify-center gap-3">
                              <form method="dialog">
                                <button className="px-6 py-3 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-all duration-200">
                                  Annuler
                                </button>
                              </form>
                              <button
                                onClick={() => {
                                  setIsDeleting(true);
                                  deleteItem(
                                    `commericiale/abonnement/v3/${selectedId}/supprimer-vente?motif=${motif}`,
                                  )
                                    .then(() => {
                                      document
                                        .getElementById("delete-intention")
                                        .close();
                                      intentions.intentionList(
                                        { page: 0, param: ``, size: 8 },
                                        `&statusSuppression=${active.status}&status=${statusIntention}&date=&isActive=true&sousMenu=${
                                          location.pathname.split("/")[2]
                                        }`,
                                      );
                                      toast.success(
                                        "Abonnement supprimé avec succès",
                                      );
                                    })
                                    .catch((err) => {
                                      toast.error(
                                        err?.response?.data?.donnee ||
                                          "Erreur lors de la suppression",
                                      );
                                    })
                                    .finally(() => {
                                      setIsDeleting(false);
                                      const dlg =
                                        document.getElementById(
                                          "delete-intention",
                                        );
                                      if (dlg) dlg.close();
                                    });
                                }}
                                disabled={isDeleting}
                                className={`px-6 py-3 rounded-lg font-medium text-sm transition-all duration-200 flex items-center gap-2 ${
                                  isDeleting
                                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                    : "bg-red-600 hover:bg-red-700 text-white"
                                }`}
                              >
                                {isDeleting ? (
                                  <div className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                                ) : (
                                  <Trash2 className="h-4 w-4" />
                                )}
                                {isDeleting
                                  ? "Suppression..."
                                  : "Faire la demande"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </dialog>
                      <dialog
                        id={`show${item.id}`}
                        className="modal bg-slate-900/70"
                      >
                        <div className="modal-box w-11/12 max-w-2xl">
                          <div className="flex items-center justify-between p-3">
                            <div className="flex flex-row gap-2">
                              <div className=" flex justify-center items-center rounded-full bg-[#ffcb05] w-8 h-8"></div>
                              <h2 className="font-extrabold flex flex-row items-center text-sm text-[#000000a8]">
                                Details d'intention
                              </h2>
                            </div>
                            <form method="dialog">
                              <button
                                id="fermer_create_trajet"
                                className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                              >
                                ✕
                              </button>
                            </form>
                          </div>
                          <DetailIntention item={item} />
                        </div>
                      </dialog>

                      <dialog id="edit" className="modal ">
                        <div className="modal-box w-10/12 max-w-2xl">
                          <div className="modal-action">
                            <h1 className="mr-auto text-2xl font-bold font-mtn">
                              Modification de l'abonnement
                            </h1>
                            <form method="dialog">
                              <button
                                id="fermer"
                                className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                              >
                                ✕
                              </button>
                            </form>
                          </div>
                          <p className="text-sm text-red-500">{message}</p>
                          <UpdateDemandeIntention
                            setMessage={setMessage}
                            item={selectItems ?? ""}
                          />
                        </div>
                      </dialog>
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <ContentLoading />
          )}
        </div>
      ) : null}
      <div className="my-3 flex justify-end">
        {active ? (
          <Pagination
            onChange={(event, newValue) => more(newValue)}
            onSelect={(selectedPage) => more(selectedPage)}
            count={intentions?.data?.totalPages}
            variant="outlined"
            color="primary"
            shape="rounded"
          />
        ) : null}
      </div>
    </div>
  );
};

export default ListeAbonnements;
